import type { PreparedNiftiAsset } from '../types/dicom';

export function getNiftiAlignmentLabel(
  asset?: Pick<PreparedNiftiAsset, 'variant' | 'alignment_mode'>,
  _hasUnsavedTransform = false
) {
  if (asset?.variant !== 'aligned') return 'Original';
  return 'Oriented';
}
